import Model from '@/store/model';
import User from './user';
import TopUsers from './top_users';
import PreviousChampions from './previous_champions';


class League extends Model {
  map(json) {
    super.map(json);

    if (json.user !== undefined && json.user !== null) {
      this.user = new User();
      this.user.map(json.user);
    }

    if (json.top_users !== undefined && json.top_users !== null) {
      this.mapArray('topUsers', json.top_users, TopUsers);
    }

    if (json.previous_champions !== undefined && json.previous_champions !== null) {
      this.mapArray('previousChampions', json.previous_champions, PreviousChampions);
    }
  }
}
export default League;
